import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";
import { Reaction } from "./Reaction.jsx";
import { makeReactionPropsByParentSelector } from "../../store/selectors/selector.reactions.jsx";

export const LeavedReaction = ({ type, parentType, parentId, onClick, disableTooltip, disableToggle }) => {
  const getReactionPropsByParent = useMemo(makeReactionPropsByParentSelector, []);

  const { content: title, ...props } = useSelector((state) => {
    return getReactionPropsByParent(state, parentType, parentId, type);
  });

  const handleClick = useCallback(() => {
    typeof onClick === "function" && onClick(type);
  }, [onClick, type]);

  return (
    <Tooltip
      title={title}
      disable={disableTooltip}
    >
      <Reaction
        {...props}
        onClick={handleClick}
        disableToggle={disableToggle}
      />
    </Tooltip>
  );
};

LeavedReaction.propTypes = {
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disableTooltip: PropTypes.bool,
  disableToggle: PropTypes.bool,
};

LeavedReaction.defaultProps = {
  disableTooltip: false,
  disableToggle: false,
};
